// Marketing consent wording for the customer enrolment form.
//
// Under UK GDPR/PECR marketing consent has to be a separate, unticked choice
// rather than something bundled into the terms, and a business needs to be
// able to show what a customer actually agreed to. The version is therefore
// stored with every consent and MUST be bumped whenever the label wording
// changes.
export const MARKETING_CONSENT_VERSION = "2026-10-v1";

// Names the business so the customer knows who will be emailing them. The
// generic wording only covers a business with no display name (or the moment
// before it has loaded).
export const marketingConsentLabel = (businessName) => {
  const name = String(businessName || "").trim();
  return name
    ? `Email me news, offers and review requests from ${name}`
    : "Email me news, offers and review requests";
};
